exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-header {\r\n  background-color: #f8f9fa;\r\n  border-bottom: 2px solid #dee2e6;\r\n}\r\n\r\n.modal-title {\r\n  font-weight: 600;\r\n  color: #333;\r\n}\r\n\r\n.form-group label {\r\n  margin-bottom: 0.5rem;\r\n  color: #495057;\r\n}\r\n\r\n.alert {\r\n  margin-top: 1rem;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.alert i {\r\n  margin-right: 0.5rem;\r\n}\r\n\r\n.spinner-border-sm {\r\n  width: 1rem;\r\n  height: 1rem;\r\n  border-width: 0.15em;\r\n}\r\n\r\n.ml-2 {\r\n  margin-left: 0.5rem;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/internal-frontend/src/app/content-page/admin/create-operating-standard/opst-step-eight/edit-standard-number-popup/edit-standard-number-popup.component.css
// module id = ../../../../../src/app/content-page/admin/create-operating-standard/opst-step-eight/edit-standard-number-popup/edit-standard-number-popup.component.css
// module chunks = main